import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';
import { buttonFontVars } from './Button.palette';

export const snapButtonStandardVars = {
  // = `calc(${m('--spacing-s')} - 1px) calc(${m('--spacing-xl')} - 1px)`. Concrete for Figma tokens
  '--button-regular-padding': '11px 31px',
  // = `calc(${m('--spacing-xs')} - 1px) calc(${m('--spacing-m')} - 1px)`. Concrete for Figma tokens
  '--button-compact-padding': '7px 15px',
  '--button-border-width': '2px',
  '--button-border-radius': '64px',
  '--button-hover-shadow': 'none',
  '--button-active-shadow': 'none',
  '--button-hover-transform-size': '0px',
  '--button-active-transform-size': '0px',
} as const;

export const snapButtonPrimaryVars: MotifComponentProps<MotifComponent.BUTTON> = {
  '--button-flat-fg-color': m('--neutral-v700'),
  '--button-flat-hover-fg-color': m('--neutral-v600'),
  '--button-primary-bg-color': m('--neutral-v700'),
  '--button-primary-border-color': m('--neutral-v700'),
  '--button-primary-fg-color': m('--neutral-v0'),
  '--button-primary-hover-bg-color': m('--neutral-v625'),
  '--button-primary-hover-border-color': m('--neutral-v625'),
  '--button-primary-hover-fg-color': m('--neutral-v0'),
  '--button-secondary-bg-color': m('--neutral-v0'),
  '--button-secondary-border-color': m('--neutral-v700'),
  '--button-secondary-fg-color': m('--neutral-v700'),
  '--button-secondary-hover-bg-color': m('--neutral-v150'),
  '--button-secondary-hover-border-color': m('--neutral-v700'),
  '--button-secondary-hover-fg-color': m('--neutral-v700'),
  ...buttonFontVars,
  ...snapButtonStandardVars,
} as const;

export const snapButtonSecondaryVars: MotifComponentProps<MotifComponent.BUTTON> = {
  '--button-flat-fg-color': m('--neutral-v0'),
  '--button-flat-hover-fg-color': m('--neutral-v200'),
  '--button-primary-bg-color': m('--neutral-v0'),
  '--button-primary-border-color': m('--neutral-v0'),
  '--button-primary-fg-color': m('--neutral-v700'),
  '--button-primary-hover-bg-color': m('--neutral-v200'),
  '--button-primary-hover-border-color': m('--neutral-v200'),
  '--button-primary-hover-fg-color': m('--neutral-v700'),
  '--button-secondary-bg-color': m('--neutral-v700'),
  '--button-secondary-border-color': m('--neutral-v0'),
  '--button-secondary-fg-color': m('--neutral-v0'),
  '--button-secondary-hover-bg-color': m('--neutral-v650'),
  '--button-secondary-hover-border-color': m('--neutral-v0'),
  '--button-secondary-hover-fg-color': m('--neutral-v0'),
  ...snapButtonStandardVars,
  ...buttonFontVars,
} as const;
